import React, { useState } from 'react'
import CustomAlert from '../../events/components/CustomAlert'
import { Box, Button, Typography, getContrastRatio } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { updateReviewState } from '../../../redux/reviewSlice'
import CheckIcon from "../../../components/icons/CheckIcon";
import { LoadingButton } from "@mui/lab";
import "@fontsource/rubik";
import { useMutation } from 'react-query'
import { acceptFinalVideo } from '../../../services/api'
import useAcceptFinalVideo from '../hooks/useAcceptFinalVideo'
import useCustomTheme from '../../../theme/useCustomTheme'
import { fileFormat, generateLighterContrastColor } from '../../../utils/commonServices'
import useRevisionActions from '../useRevisionActions'
import CustomInput from "../../eventcreation/components/CustomInput";
import CustomTooltip from '../../../components/CustomTooltip'



const AcceptVideoPopup = (props) => {
    const {open, acceptRequest, status} = props;
    const dispatch = useDispatch()
    const reviewEventReducer = useSelector((state)=>state.reviewEventReducer)
    const { acceptInternalRevision} = useRevisionActions()
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const [theme ] = useCustomTheme()
    const [videoName, setVideoName] = useState()

    const handleClose = () => {
        dispatch(updateReviewState({open_video_accept_popup : false}))    
       };



    const acceptVideoHandler =()=>{
        // send api req to accept video
        const payload = {
          id: reviewEventReducer?.internal_revision_id,
          new_filename: videoName ? `${videoName}.${fileFormat(reviewEventReducer?.current_internal_revision?.filename )}` : reviewEventReducer?.current_internal_revision?.filename 
        }
        acceptInternalRevision(payload, handleClose)
       // acceptRequest({final_video_id: commonReducer.event_details?.final_video_id})    
        // dispatch(updateReviewState({open_video_accept_popup : false})) 
    }

    const handleChange = (event) => {
      // setVideoName(event.target.value.replace(".", ""))
      // setVideoName(event.target.value.replace(/[^A-Za-z0-9\-@_#]/g, ''))   //without space
      // setVideoName(event.target.value.replace(/[^A-Za-z0-9\-@_# ]/g, ''))  //with space

      const cleanedValue = event.target.value
      .replace(/[^A-Za-z0-9\-@_ ]/g, '')   // remove disallowed characters
      .replace(/\s{2,}/g, ' ');             // collapse multiple spaces to one
  
    setVideoName(cleanedValue);
    }

    return (
    
        <CustomAlert 
          open={open} 
          handleClose={handleClose} 
          width={{xs:'400px',sm:'400px',md:'420px',lg:'440px', xl:'600px'}}
          height={{xs:'350px',sm:'330px',md:'350px',lg:'375px', xl:'450px'}}
        >
           <Box p={5} className="flex col" sx={{justifyContent:'space-evenly', height:'100%'}}>
          
            <Box   mb={{xs:1 ,md:2, lg:4}}>
              <Typography variant="h4" sx={{fontFamily:'Rubik', fontSize:{xs:'13px',sm:'13px',md:'13px',lg:'13px',xl:'18px'}, color:'black'}}>If you want to rename this file, enter new name below (without extension). To keep the original name, leave the box empty. Once you accept this video it will be visible to clients.</Typography>
            </Box>
           
            <Box>
                <CustomTooltip
                          arrow
                          // enterTouchDelay={0}
                          // leaveTouchDelay={5000}
                          title={<Box>
                                  <Typography variant="body1"> Video name can include: </Typography>
                                  <Typography variant="body1"> - uppercase characters (A-Z)  </Typography>
                                  <Typography variant="body1"> - lowercase characters (a-z) </Typography>
                                  <Typography variant="body1"> - digits (0-9) </Typography>
                                  <Typography variant="body1"> - special characters (-,@,_,) </Typography>
                                  <Typography variant="body1"> - max 100 charcters in length </Typography>
                              </Box>}
                          // placement={window.innerWidth <= 1100 ? "bottom" : "right"}
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: window.innerWidth >= 1100 && [0, 0],
                                },
                              },
                            ],
                          }}
                        >

                          <CustomInput  max={100} onChange={handleChange} value={videoName}  placeholder = "Video Name" light/>
                </CustomTooltip>
            </Box>
    
            <Box sx={{display:'flex',justifyContent:'end' }} mt={{xs:1 ,md:3}} >
    
             

              { reviewEventReducer?.accept_internal_revision_loading ? <LoadingButton
                   // size="small"
                    sx={{
                        '& .MuiLoadingButton-loadingIndicator': {
                            color: theme.palette.primary.main,
                        },
                        height: {xs:'36px',sm:'40px',md:'45px', lg:'51px',xl:'75px'},
                       minWidth: {xs:'36px !important',sm:'40px !important',md:'45px !important', lg:'51px !important',xl:'75px !important'},
                        backgroundColor: '#08231B'
                    }}
                    loading={reviewEventReducer?.accept_internal_revision_loading}
                    variant="outlined"
                    disabled
                    >
                   
               </LoadingButton> :
               <CheckIcon color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} onClick= {acceptVideoHandler}  sx={{fontSize:{xs:'40px',sm:'44px',md:'50px', lg:'56px',xl:'82px'}, cursor:  'pointer',}}/>
               }

              {/* <Button
                    // disabled={!checked || addConsentLoading}
                  
                    style={{borderRadius: '5px', backgroundColor:'#08231B', color:theme.palette.primary.main, textTransform:'none', }} 
                    sx={{ fontSize:{xs:'9px',sm:'9px',md:'9px',lg:'11px',xl:'16px', },fontWeight:600, width:{xs:'76px',sm:'76px',md:'76px',lg:'86px',xl:'129px'},  opacity: !checked && 0.7, minWidth: '110px !important'}}
                    // loading={addConsentLoading}
                    // loadingPosition="start"
                    variant="contained"
                    >
                   Continue
               </Button>  */}
            </Box>
           </Box>
        </CustomAlert>
      
  )
}

export default AcceptVideoPopup